.ncc { display: flex; gap: 8px; flex-wrap: wrap; }
.ncc button { height: 36px; padding: 0 14px; border: 0; border-radius: 10px; background: var(--card); color: var(--tx); box-shadow: var(--sh); font: inherit; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
.ncc button[aria-pressed='true'] { background: var(--pri-bg); color: var(--link); box-shadow: inset 0 0 0 1px var(--pri-bd); }
.kpis { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; }
.grid { display: grid; grid-template-columns: minmax(0, 1fr) 320px; gap: 14px; align-items: start; }
.row { display: grid; grid-template-columns: 100px 150px 130px 1fr 100px 100px 100px; padding: 0 18px; height: 49px; align-items: center; border-bottom: 1px solid var(--line); }
.head { height: 40px; font-size: 12px; color: var(--lb); }
.row > b { font-weight: var(--fw-label); }
.note { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.side { display: flex; flex-direction: column; gap: 12px; }
.box { padding: 14px 16px; display: flex; flex-direction: column; gap: 8px; }
.ages { gap: 0; }
.ages h2 { margin-bottom: 8px; }
.age:first-of-type { margin-top: 0; }
.box h2 { margin: 0; font-size: 15px; font-weight: var(--fw-title); }
.box h2 svg { margin-right: 6px; vertical-align: -3px; color: var(--tx2); }
.bt { display: flex; align-items: center; gap: 8px; }
.bt h2 { flex-grow: 1; }
.mini { display: inline-flex; align-items: center; gap: 6px; height: 30px; padding: 0 10px; border: 0; border-radius: 9px; background: var(--ctl); color: var(--tx); font: inherit; font-size: 12px; font-weight: var(--fw-label); white-space: nowrap; cursor: pointer; }
.two { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; }
.two > div { padding: 8px 10px; border-radius: 10px; background: var(--sub); }
.two span { display: block; font-size: 12px; color: var(--lb); }
.two b { font-weight: var(--fw-title); }
.age { display: grid; grid-template-columns: 80px 1fr 56px; align-items: center; gap: 10px; height: 28px; }
.age span { font-size: 12px; color: var(--tx2); }
.age b { font-weight: var(--fw-label); text-align: right; }
.track { display: block; height: 8px; border-radius: 4px; background: var(--line); overflow: hidden; }
.track > i { display: block; height: 100%; }
.doc { font-size: 12px; color: var(--tx2); }
.btn { height: 36px; border: 1px solid var(--bd); border-radius: 10px; background: var(--card); color: var(--tx); font: inherit; font-weight: var(--fw-label); cursor: pointer; display: inline-flex; align-items: center; justify-content: center; gap: 6px; white-space: nowrap; }
.ok { color: var(--ok); }
